export default __webpack_public_path__ + "static/media/icon-256x256.5cd45cf7.png";